<template>
    <div class="hot-question-edit">
        <div class="hot-edit-content" @mousemove="moveHandle" @mouseout="outHandle">
            <IconInput class="hot-question-title" :initValue="data.hotTitle" @inputChange="titleChange" :placeholder="titleLabel" />
            <div class="linked-question-search">
                <span class="question-search" @click="questionClick">{{ data.question || defaultQuestion }}</span>
            </div>
            <div class="delete-icon">
                <Icon
                    v-show="canDelete && showDelete"
                    @iconClick="deleteHandle"
                    :bgPosition="bgPosition"
                    :hoverBgPosition="hoverBgPosition"
                />
            </div>
        </div>
        <HotPointPanel
            class="hot-panel"
            :data="hotPointData"
            @redSwitch="redSwitch"
            @hotSwitch="hotSwitch"
            @endDateChange="hotDateChange"
        />
    </div>
</template>

<script>
import Icon from "@/views/zhiji/bComponents/icons/Icon";
import IconInput from "@/views/zhiji/bComponents/inputs/IconInput";
import i18n from "@/i18n";
import HotPointPanel from "../HotPointPanel.vue";

export default {
    name: "HotEditItem",
    props: ["data", "count"],
    components: {
        Icon,
        IconInput,
        HotPointPanel,
    },
    data() {
        return {
            bgPosition: "-94px 0",
            hoverBgPosition: "-94px -22px",
            showDelete: false,
        };
    },
    model: {
        prop: "data",
        event: "update"
    },
    computed: {
        titleLabel() {
            return this.$t("zhiji.answer.hotTitleTip");
        },
        canDelete() {
            return this.count > 2;
        },
        defaultQuestion() {
            return this.$t("zhiji.answer.textWidget.linkQuestion");
        },
        hotPointData() {
            return {
                redState: this.data.redState,
                hotItem: this.data.hotItem,
                endTime: this.data.redHotEndTime
            };
        },
    },
    methods: {
        titleChange(hotTitle) {
            this.$emit("update", { ...this.data, hotTitle });
        },
        deleteHandle() {
            this.$emit("deleteItem", this.data)
        },
        moveHandle() {
            this.showDelete = true;
        },
        outHandle() {
            this.showDelete = false;
        },
        redSwitch(redState) {
            this.$emit("update", { ...this.data, redState });
        },
        hotSwitch(hotItem) {
            this.$emit("update", { ...this.data, hotItem });
        },
        hotDateChange(redHotEndTime) {
            this.$emit("update", { ...this.data, redHotEndTime });
        },
        questionClick() {
            this.$store.dispatch("zhiji/showModal", {
                type: "QuestionSelectorTableModal",
                data: {
                    title: i18n.t("zhiji.answer.textWidget.linkQuestion"),
                    questionId: parseInt(this.data.questionId),
                    currentLang: this.$store.state.zhiji.questionEdit.currentSynonym,
                    confirm: data => {
                        this.questionSelected(data);
                    }
                }
            });
        },
        questionSelected(data) {
            const { question, questionId, optionTip } = data;
            const hotTitle = optionTip;
            if (!question) {
                return;
            }
            this.$emit("update", { ...this.data, question, questionId, hotTitle });
        },
    }
};
</script>

<style lang="less" scoped>
.hot-question-edit {
    .hot-edit-content {
        display: flex;
        .hot-question-title {
            width: 250px;
            background: #fff;
            margin-right: 10px;
            border: solid 1px #d8e4f0;
            border-radius: 4px;
        }
        .linked-question-search {
            border: solid 1px #d8e4f0;
            margin-right: 10px;
            border-radius: 4px;
            margin-bottom: 5px;

            .question-search {
                display: block;
                background: #ffffff;
                border: 1px solid #d8e4f0;
                border-radius: 4px;
                width: 240px;
                height: 30px;
                padding: 0 8px;
                box-sizing: border-box;
                line-height: 28px;
                cursor: pointer;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                &:hover {
                    color: #2ec2ff;
                }
            }
        }
    }
    .delete-icon {
        line-height: 32px;
        width: 18px;
    }
    .hot-panel {
        background-color: #fff;
        border-radius: 4px;
        border: solid 1px #d8e4f0;
        border-top: none;
        margin-bottom: 12px;
        margin-right: 26px;
    }
}
</style>
